import React, {useEffect, useState} from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import sellerimage from "../../../images/Group 1000001628.png";
import bannerimage from "../../../images/title.png";
import {loginUserAction, registerUserAction} from "../../redux/slices/userSlices";
import {useDispatch, useSelector} from "react-redux";
import "./signupwithotp.scss";
import SellerNavbar from "../../../components/SellerNavbar";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import OtpInput from 'react-otp-input';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

firebase.initializeApp(firebaseConfig);
const baseUrl = process.env.REACT_APP_BASEURL;
const apiKey = process.env.REACT_APP_NEWID;
const apiKey2 = process.env.REACT_APP_API_KEY;
console.log(apiKey2, baseUrl, process.env.REACT_APP_AUTH_DOMAIN, process.env.REACT_APP_MEASUREMENT_ID, "AIzaSyBdHW6Za9FzF5vQUBaY1cJqfM97QicxU2c", "api key");
const EcomSellerLogin = () => {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [confirmationResult, setConfirmationResult] = useState(null);
    const [verificationId, setVerificationId] = useState("");
    const [user1, setUser] = useState("");
    const state = useSelector((state) => state.sellers);
    const {sellerAuth} = state;
    console.log(sellerAuth, "jj");

    const dispatch = useDispatch();
    const navigate = useNavigate();
    console.log(phoneNumber, "phonenumber");
    const checkUserExists = async () => {
        console.log(phoneNumber, "phonenumber1");
        try {
            const response = await axios.post(`${baseUrl}/api/reseller/singleuser`, {phoneNumber: phoneNumber});
            setUser(response.data);
            console.log(response.data.length, "arraylength");
            console.log(response.data, "rrr");
        } catch (error) {
            console.error("Error checking user existence:", error);
        }
    };
    console.log(user1[0] ?. selleraction, "22");

    const handleVerifyOTP = async (e) => {
        e.preventDefault();

        try {
            const result = await confirmationResult.confirm(otp);
            const user = result.user;
            console.log(user1, "ddd");
            console.log(user1[0] ?. selleraction, "pppppp");
            console.log("loginuser", user1);
            if (user1.length > 0 && user1[0] ?. selleraction === "Completed" && user1[0] ?. approved === "Approved") { // User already exists, login
                console.log("Completed");

                await dispatch(loginUserAction({phoneNumber: phoneNumber}));

                navigate("/dashboard");
            } else if (user1.length > 0 && user1[0] ?. selleraction === "Incomplete") { // User does not exist, register
                await dispatch(loginUserAction({phoneNumber: phoneNumber}));
                navigate("/register");
            } else if (user1.length > 0 && user1[0] ?. selleraction === "Completed" && user1[0] ?. approved === "Pending") {
                navigate("/confirmation");
            } else if (user1.length > 0 && user1[0] ?. approved === "Rejected") {
                navigate("/confirmation");
            } else {
                await dispatch(registerUserAction({phoneNumber: phoneNumber}));
                navigate("/register");
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);
            toast.error(error)
        }
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        const appVerifier = new firebase.auth.RecaptchaVerifier("recaptcha-container", {size: "invisible"});
        const fullPhoneNumber = "+91" + phoneNumber;
        const newphonenumber = localStorage.setItem("phoneNumber", phoneNumber);
        console.log(newphonenumber, "jjj");
        const storedPhoneNumber = localStorage.getItem("phoneNumber");
        console.log(storedPhoneNumber, "yyy");
        setVerificationId(storedPhoneNumber);
        firebase.auth().signInWithPhoneNumber(fullPhoneNumber, appVerifier).then((confirmationResult) => {
            setConfirmationResult(confirmationResult);
            checkUserExists(); // Call checkUserExists here
            toast.success("OTP send successfully");
        }).catch((error) => {
            console.error("Error sending OTP:", error);
            toast.error("Error sending OTP");
        });
    };

    // Rest of the code remains the same

    const apiKey = process.env.REACT_APP_API_KEY;
    console.log(apiKey, "hh");
    useEffect(() => {
        localStorage.removeItem("sellerregisterInfo");
        localStorage.removeItem("phoneNumber");
    }, []);
    return (
        <div>
            <SellerNavbar/>
            <ToastContainer/>

            <div className="sellercontainer">
                <div className="sellerintro">
                    <p className="sellerintrotitle">Sell With Us Be Our
                        <br/>
                        Partner</p>
                    <p className="sellerintrotext">Join our booming seller community to increase your exposure
                        <br/>and access a large customer base.</p>
                    <img src={sellerimage}
                        alt=""
                        className="sellerbannersecondimage"/>
                </div>
                <div className="sellerlogindiv">
                    <div style={
                        {margin: "30px 0"}
                    }>
                        <p>

                            <span style={
                                {color: "#3D463D"}
                            }>(Note)</span>
                            <span style={
                                {color: "#DF2F08"}
                            }>We Only deal with electronics based products</span>
                        </p>
                    </div>
                    <div className="sellerlogin">
                        <p className="sellerlogintext">Login Or Register</p>
                        <div className="sellerlogininputandsendotpbutton">
                            <form className={
                                    phoneNumber.length === 10 ? "sellersendotpformactive" : "sellersendotpform"
                                }
                                onSubmit={handleFormSubmit}>
                                <p className="sellerlogininputtextfieldlabel">&nbsp; Enter Mobile Number <span className="redstarlogin">*</span> &nbsp;</p>
                                <p className="sellerlogininputnumber">+91</p>
                                <input className="sellerlogininput" type="tel" placeholder="Phone number"
                                    value={phoneNumber}
                                    required
                                    onChange={
                                        (e) => setPhoneNumber(e.target.value)
                                    }/>
                                <button disabled={
                                        phoneNumber.length !== 10
                                    }
                                    className={
                                        phoneNumber.length === 10 ? "sellerloginsendotpactive" : "sellerloginsendotp"
                                    }
                                    type="submit">
                                    Send OTP
                                </button>
                            </form>

                            {
                            confirmationResult && (
                                <div className="sellerregisterwithdiv">
                                    <form className="sellerregisterform"
                                        onSubmit={handleVerifyOTP}>
                                        {/* <input className="otpinput" type="text" placeholder="OTP"
                                            value={otp}
                                            onChange={
                                                (e) => setOtp(e.target.value)
                                            }/> */}
                                            <OtpInput
                                                value={otp}
                                                onChange={setOtp}
                                                inputStyle={otp?"sellerlogininputotpactive":"sellerlogininputotp"}
                                                containerStyle={{display:"flex",justifyContent:"space-between"}}
                                                numInputs={6}
                                                renderSeparator={<span>&nbsp;</span>}
                                                renderInput={(props) => <input {...props} />}
                                                />
                                        <button type="submit" className="registerandcontinuewithotpbutton">
                                            Register and Continue
                                        </button>
                                    </form>
                                </div>
                            )
                        } </div>
                    </div>
                </div>
            </div>
            <div id="recaptcha-container"></div>
        </div>
    );
};
export default EcomSellerLogin;
